import { useRef, ReactNode, useState, useEffect, memo } from "react";
import { LngLat } from "@yandex/ymaps3-types";
import { useYandexMaps } from "@boundary/_hooks/useYandexMaps";
import styles from "./yandexMap.module.scss";

interface MapLocation {
  center: LngLat;
  zoom: number;
}

interface YandexMapProps {
  location?: MapLocation;
  onMapReady?: (map: unknown) => void;
  children?: ReactNode;
  common?: ReturnType<typeof useYandexMaps>["Common"];
}

const defaultLocation: MapLocation = {
  center: [37.64, 55.76] as LngLat,
  zoom: 15
};

function YandexMapComponent({ location, onMapReady, children, common }: YandexMapProps) {
  const { Common: hookCommon } = useYandexMaps();
  const Common = common || hookCommon;
  const mapRef = useRef<unknown>(null);
  const mapReadyLogged = useRef(false);
  
  // Используем location из props напрямую (без useState)
  // Если location не передан - используем defaultLocation
  const currentLocation = location || defaultLocation;

  const handleRef = (v: unknown) => {
    mapRef.current = v;
    if (v && onMapReady && !mapReadyLogged.current) {
      mapReadyLogged.current = true;
      onMapReady(v);
    }
  };

  // Если Common еще не загружен, показываем пустой div с фоном приложения
  // Это предотвращает мерцание и темный экран при загрузке
  if (!Common) {
    return <div className={styles.container} />;
  }

  return (
    <Common.YMap ref={handleRef} location={currentLocation} mode="vector">
      <Common.YMapDefaultSchemeLayer />
      <Common.YMapDefaultFeaturesLayer />
      {children}
    </Common.YMap>
  );
}

// УБРАН memo - он блокирует обновление children (маркеров)
// Yandex Maps сам оптимизирует рендеринг через внутренний reconciliation
export const YandexMap = YandexMapComponent;

